import { render, staticRenderFns } from "./keyboard.vue?vue&type=template&id=7960ec41&"
import script from "./keyboard.vue?vue&type=script&lang=js&"
export * from "./keyboard.vue?vue&type=script&lang=js&"
import style0 from "./keyboard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\笑笑\\Desktop\\pay-pos-spa\\pay-pos-spa\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7960ec41')) {
      api.createRecord('7960ec41', component.options)
    } else {
      api.reload('7960ec41', component.options)
    }
    module.hot.accept("./keyboard.vue?vue&type=template&id=7960ec41&", function () {
      api.rerender('7960ec41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/twoInOne/keyboard.vue"
export default component.exports